import * as React from 'react';
import { TeamCard } from './TeamCard/TeamCard';
import bicon from "../../assets/b-badge.png";
import duhicon from "../../assets/duh-badge.png";
import raphabadge from "../../assets/rapha-badge.png";
import claubadge from "../../assets/clau-badge.png";
import enciclobadge from "../../assets/enciclochan-badge.png";
import biconalt from "../../assets/b-badge-alt.png";
import duhiconalt from "../../assets/duh-badge-alt.png";
import raphabadgealt from "../../assets/rapha-badge-alt.png";
import claubadgealt from "../../assets/clau-badge-alt.png";
import enciclobadgealt from "../../assets/enciclochan-badge-alt.png";

const aboutTeam = [
    {
        name: "Enciclo-chan",
        role: "Staff da LQN",
        content: "Apoie com qualquer quantia para que a Enciclo-chan continue catalogando quadrinhos nacionais!",
        icon: enciclobadge,
        altIcon: enciclobadgealt,
        title: "Ajude a Enciclo-chan",
        hover: false,
        link: "https://ko-fi.com/duhgetsu"
    },
    {
        name: "Duh",
        role: "Moderador da LQN",
        content: "Acesse a wiki de quadrinhos nacionais e nos ajuda a registrar todos os quadrinhos!",
        icon: duhicon,
        altIcon: duhiconalt,
        title: "Wiki de Quadrinhos",
        hover: false,
        link: "http://wiki.enciclopedialqn.com.br"
    },
    {
        name: "Bernardo",
        role: "Criador da LQN",
        content: "Youtube, instagram, tiktok... A LQN traz uma enchurrada de conteúdinho, não perca nada!",
        icon: bicon,
        altIcon: biconalt,
        title: "Links da LQN",
        hover: false,
        link: "https://linktr.ee/bsougo"
    },
    {
        name: "Rapha",
        role: "Moderador da LQN",
        content: "Lendo em twitch.tv/bernardolqn todas as Quintas e Domingos a partir das 21:00hrs.",
        icon: raphabadge,
        altIcon: raphabadgealt,
        title: "Siga nossas lives!",
        hover: false,
        link: "https://twitch.tv/bernardolqn"
    },
    {
        name: "Clau Mazzu",
        role: "Moderadora da LQN",
        content: "O lugar onde o fandom do quadrinho nacional se encontra! Participe dos nossos chats!",
        icon: claubadge,
        altIcon: claubadgealt,
        title: "Entre na comunidade!",
        hover: false,
        link: "https://discord.gg/qqFCB6hGnf"
    },

]

const AboutPage = () => {
    const [team, setTeam] = React.useState(aboutTeam);

    const changeHover = (state, name) => {
        setTeam(team.map((t) => {
            if (name === t.name) {
                return { ...t, hover: state }
            } else {
                return t;
            }
        }))
    }

    return (
        <div style={{ display: "flex", flex: 1, flexDirection: "column", marginTop: 40 }}>
            <div style={{ flex: 1, display: "flex" }}>
                {/* <div style={{ flex: 2, display: "flex", justifyContent: "center" }}>
                    <CarouselPage />
                </div> */}
                {/* <div style={{ flex: 1, display: "flex", flexDirection: "column", justifyContent: "space-between" }}>
                    <LinksBanner />
                    <TwitchBanner />
                    <DiscordBanner/>
                    <KofiBanner />
                </div> */}
                <div style={{ flex: 1, display: "flex", flexDirection: "row", justifyContent: "space-around" }}>
                    {team.map((t) => {
                        return <div
                            class="card-about"
                            style={{ cursor: "pointer" }}
                            onMouseEnter={() => changeHover(true, t.name)}
                            onMouseLeave={() => changeHover(false, t.name)}
                            onClick={() => { window.open(t.link, '_blank'); changeHover(false, t.name); }}>
                            <TeamCard name={t.name} title={t.title} role={t.role} content={t.content} icon={t.icon} altIcon={t.altIcon} hover={t.hover} />
                        </div>
                    })}
                </div>
            </div>
        </div>
    );
}

export default AboutPage;